import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "target"]
  
  add(event) {
    event.preventDefault()
    
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    )
    
    this.targetTarget.insertAdjacentHTML('beforeend', content)
  }
  
  remove(event) {
    event.preventDefault()
    
    const wrapper = event.target.closest('.nested-fields')
    
    if (wrapper.dataset.newRecord === 'true') {
      wrapper.remove()
    } else {
      wrapper.style.display = 'none'
      
      const input = wrapper.querySelector("input[name*='_destroy']")
      input.value = '1'
    }
  }
}

